define('common/clientSniffer',[
    'knockout',
    'jquery',
    'UAParser',
    'common/flashSniffer',
    'underscore',
    'common/createCookieAccessor'
], function(ko, $, UAParser, flashSniffer, _, createCookieAccessor) {

    function ClientSniffer(uastring) {
        var self = this,
            $window = $(window),
            parser = new UAParser(),
            client,
            browserSize;

        // If the object is instanced with an actual User Agent string, we use that one
        // for parsing the client details. Otherwise we use the default implementation,
        // allowing UAParser itself to breakdown window.navigator.userAgent under the hood.
        _.isString(uastring) && parser.setUA(uastring);

        client = parser.getResult();

        self.OS = client.os; // { name: '', version: '' }

        self.device = client.device; // { model: '', type: '', vendor: '' }

        if(window.screen) {
            self.device.resolution = {
                width: window.screen.width,
                height: window.screen.height,
                colorDepth: window.screen.colorDepth + ' bit'
            };
        }

        self.isRetina = window.devicePixelRatio && window.devicePixelRatio >= 2;

        self.browser = client.browser; // { name: '', major: '', version: '' }

        self.browser.flashVersion = flashSniffer.installed ? flashSniffer.raw : 'Not installed';

        self.browser.isIE10 = (self.browser.name === 'IE' && self.browser.major === '10');
        self.browser.isIE11 = (self.browser.name === 'IE' && self.browser.major === '11');

        browserSize = {
            width: ko.observable($window.width()),
            height: ko.observable($window.height())
        };

        $window.resize(function () {
            browserSize.width($window.width());
            browserSize.height($window.height());
        });

        self.browser.browserSize = ko.pureComputed(function() {
            return ko.toJS(browserSize);
        });
    }

    ClientSniffer.prototype.parseUA = function (uastring) {
        return new ClientSniffer(uastring);
    };

    ClientSniffer.prototype.supportsFlash = function () {
        return flashSniffer.installed;
    };

    ClientSniffer.prototype.supportsCookies = function () {
        return createCookieAccessor.areCookiesEnabled;
    };

    ClientSniffer.prototype.supportsLocalStorage = function () {
        var storageSupported,
            storage,
            uid = new Date();
        try {
            (storage = window.localStorage).setItem(uid, uid);
            storageSupported = storage.getItem(uid) === uid;
            storage.removeItem(uid);
        } catch(e) {
            storageSupported = false;
        }
        return storageSupported;
    };

    ClientSniffer.prototype.supportsWebSockets = function() {
        var self = this, exclusions = [];
        // *** Set exclusions below
        exclusions.push(self.OS.name === 'Android' && self.OS.version.substr(0, 3) === '4.0');

        return !_.includes(exclusions, true);
    };

    ClientSniffer.prototype.supportsFlashDirectMode = function() {
        var self = this, exclusions = [];
        // *** Set exclusions below
        exclusions.push(self.browser === 'IE');
        exclusions.push(self.browser === 'Firefox' && self.OS === 'Windows'); //TODO: Check if this still applies

        return !_.includes(exclusions, true);
    };

    ClientSniffer.prototype.features = function () {
        var self = this,
            OS = self.OS,
            device = self.device,
            browser = self.browser,
            browserSize = browser.browserSize(),
            resolution = device.resolution,
            features = [],
            supported = function(condition) {
                return condition ? 'Supported' : 'Non supported';
            };

        features.push(_.str.sprintf('OS version: %s %s', OS.name, OS.version));
        resolution && features.push(_.str.sprintf('Display resolution: %sx%s %s', resolution.width, resolution.height, resolution.colorDepth));
        features.push(_.str.sprintf('Browser: %s %s', browser.name, browser.version));
        features.push(_.str.sprintf('Browser size: %sx%s', browserSize.width, browserSize.height));
        features.push(_.str.sprintf('Flash version: %s', browser.flashVersion));
        features.push(_.str.sprintf('Cookies: %s', supported(self.supportsCookies())));
        features.push(_.str.sprintf('Local storage: %s', supported(self.supportsLocalStorage())));

        return features;
    };

    return new ClientSniffer();
});

